import { createContext } from 'react';

const laboratoryContext = createContext();

export default laboratoryContext;
